import type { EmailNotificationSettings } from '../../../contracts';

const getUpdateEmailNotificationBody = (updateType: string): EmailNotificationSettings => {
  switch (updateType) {
    case 'subscribe':
      return {
        isSubscribedToAlerts: true,
        isSubscribedToEvents: true,
        isSubscribedToPromotions: true,
        isSubscribedToOffers: true,
        isSubscribedGlobal: true
      };
    case 'unsubscribe':
      return {
        isSubscribedToAlerts: false,
        isSubscribedToEvents: false,
        isSubscribedToPromotions: false,
        isSubscribedToOffers: false,
        isSubscribedGlobal: false
      };
    default:
      break;
  }

  return {};
};

export default getUpdateEmailNotificationBody;
